module.exports = __webpack_public_path__ + "static/media/trophy-finish-lecture.241a6cae.svg";